/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserPopoverOverviewContainer_settings = {
    readonly memberBios: boolean;
    readonly " $refType": "UserPopoverOverviewContainer_settings";
};
export type UserPopoverOverviewContainer_settings$data = UserPopoverOverviewContainer_settings;
export type UserPopoverOverviewContainer_settings$key = {
    readonly " $data"?: UserPopoverOverviewContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverOverviewContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPopoverOverviewContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberBios",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'c06afebc8424a599b6d7b93ec97a8762';
export default node;
